// extracted by mini-css-extract-plugin
export default {"container":"terms_container__uwzW2"};